export enum ShoppingCartUploadProcessingState {
    Idle,
    Running,
    Finished,
    Error,
}
